import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AuditSubscriptionRoutes = defineRoute({
    record: {
        route: {
            path: "/audit-subscription",
            component: () => loadView(import("./AuditSubscriptionTable.vue")),
        },
    },
    selectRecord: {
        route: {
            path: "/audit-subscription-select",
            component: () => loadView(import("./AuditSubscriptionSelectTable.vue")),
        },
    },
});
